import React from 'react';
import { useSecondarySMSVerificationPresenter } from './SecondarySMSVerification.presenter';

import * as S from './SecondarySMSVerification.styles';

export const SecondarySMSVerification = ({
  appId,
  dealerId,
  customer,
  isFirstSend,
  onClose,
  onSuccess,
}) => {
  const presenter = useSecondarySMSVerificationPresenter({
    appId,
    dealerId,
    customer,
    isFirstSend,
  });

  return (
    <S.StyledPopup onClose={onClose} dataTest="SMSVerification-popup">
      <S.Container>
        <S.Title>Подписание согласия клиента</S.Title>
        <S.Description>
          Мы отправили новый код на номер {customer?.contacts?.mobilePhone || ''}. Узнайте код у
          клиента
          <br />и введите ниже
        </S.Description>

        <S.PhoneVerification
          codeSize={6}
          resendTimeout={presenter.remainingTime || presenter.INITIAL_DURATION}
          disabled={presenter.isVerification}
          isResendAllowed={presenter.isViewResendButton}
          onVerification={presenter.verificationCodeHandler}
          onResend={presenter.resendCodeHandler}
          onSuccess={onSuccess}
        />
      </S.Container>
    </S.StyledPopup>
  );
};
